module.exports = __webpack_public_path__ + "build/assets/lmroman12-italic-8b3efa6eb469521fbb7d17d9a4e3f26b.woff2";